import React from "react"
import ContainerMax from "components/shared/ContainerMax"
import WPLink from "components/shared/WPLink"
import ContentMax from "components/shared/ContentMax"
import GalleryGrid from "components/shared/GalleryGrid"
import BlockTitle from "components/shared/BlockTitle"

const GalleryMasonry = (props) => {
	const { block } = props
	
	return(
		<ContainerMax className="my-4">
			<ContentMax>
				{block.title && 
					<BlockTitle baseTitle white>{block.title}</BlockTitle>
				}
				<GalleryGrid images={block.images} displayMore={false} borderOnHover={true} />
				{block.link &&
					<WPLink url={block.link.url} target={block.link.target} button color="secondary" className="mt-3">
						{block.link.title}
					</WPLink>
				}
			</ContentMax>
		</ContainerMax>
	)
}

export default GalleryMasonry